module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {

	fox.registerWidget('Layout_Settings', {

		configure: function(options) {			
			options.allowScrollTop = true;
			if (fox.site.getOption('home') == 'welcome') {
				this.embedWidget('dashboardSteps', 'Dashboard_Steps', {
					'embed.container': '.steps-wrapper'
				});
			}
			this.callParent('configure', arguments);
		}

	}, 'Layout_Base');

})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ../common/widget/layout/settings.js
// module id = 467
// module chunks = 2